import React from 'react';
import styles from './PhotoGrid.module.css';

/**
 * Inter-cell gap (px) for the shared photo grid. Single source of truth shared
 * with AlbumViewPage's virtualized grid math. Keep in sync with PhotoGrid.module.css.
 */
export const PHOTO_GRID_GAP = 2;

/** Column count for a given container width — matches the CSS breakpoints below. */
export function getPhotoGridCols(width: number): number {
  return width < 640 ? 3 : width < 768 ? 4 : width < 1024 ? 5 : 6;
}

interface PhotoGridProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Full-bleed responsive photo grid — 3→6 columns, 2px gap.
 *
 * Used by the My Photos tab and AlbumViewPage skeletons. AlbumViewPage's live
 * grid is virtualized for performance but shares this exact spec via
 * PHOTO_GRID_GAP / getPhotoGridCols.
 */
export function PhotoGrid({ children, className }: PhotoGridProps) {
  return (
    <div className={[styles['grid'], className].filter(Boolean).join(' ')}>
      {children}
    </div>
  );
}
